<template>
  <v-dialog v-model="visible" max-width="340" scrollable>
    <v-card v-if="status" color="grey darken-4" dark>
      <v-card-title class="py-2">
        <v-icon left small>mdi-robot-vacuum</v-icon>
        Schnuffel
        <v-spacer />
        <v-btn icon small @click="visible = false"><v-icon small>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-3">
        <div class="kv-grid">
          <div class="kv-label">Status</div>
          <div class="kv-value">{{ stateLabel }}</div>

          <div class="kv-label">Akku</div>
          <div class="kv-value">
            <v-icon :color="batteryColor" x-small class="mr-1">{{ batteryIcon }}</v-icon>
            {{ status.status.battery }} %
          </div>

          <div class="kv-label">Saugkraft</div>
          <div class="kv-value">{{ fanLabel }}</div>

          <div class="kv-label">Wasser</div>
          <div class="kv-value">{{ waterLabel }}</div>

          <div class="kv-label">Wischen</div>
          <div class="kv-value">{{ mopLabel }}</div>

          <div class="kv-label">Sitzung</div>
          <div class="kv-value">
            {{ status.status.square_meter_clean_area }} m² ·
            {{ Math.round(status.status.clean_time / 60) }} min
          </div>

          <template v-if="status.meta">
            <div class="kv-label">Modell</div>
            <div class="kv-value">{{ status.meta.model }}</div>

            <div class="kv-label">Firmware</div>
            <div class="kv-value">{{ status.meta.fw }}</div>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { STATE_LABELS, FAN_LEVELS, WATER_MODES, MOP_MODES } from '@/services/vacuum'

export default {
  name: 'RobotStatusDialog',
  props: {
    value: Boolean,
    status: { type: Object, default: null },
  },
  computed: {
    visible: {
      get() { return this.value },
      set(v) { this.$emit('input', v) },
    },
    stateLabel() {
      const s = this.status && this.status.status.state
      return STATE_LABELS[s] || ('State ' + s)
    },
    fanLabel() {
      const v = this.status && this.status.status.fan_power
      const o = FAN_LEVELS.find(x => x.value === v)
      return o ? o.label : v
    },
    waterLabel() {
      const v = this.status && this.status.status.water_box_mode
      const o = WATER_MODES.find(x => x.value === v)
      return o ? o.label : v
    },
    mopLabel() {
      const v = this.status && this.status.status.mop_mode
      const o = MOP_MODES.find(x => x.value === v)
      return o ? o.label : v
    },
    batteryIcon() {
      const b = this.status ? this.status.status.battery : 0
      if (b >= 95) return 'mdi-battery'
      if (b >= 80) return 'mdi-battery-80'
      if (b >= 60) return 'mdi-battery-60'
      if (b >= 40) return 'mdi-battery-40'
      if (b >= 20) return 'mdi-battery-20'
      return 'mdi-battery-alert'
    },
    batteryColor() {
      const b = this.status ? this.status.status.battery : 0
      if (b < 20) return 'red'
      if (b < 40) return 'orange'
      return 'green lighten-1'
    },
  },
}
</script>

<style scoped>
.kv-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 16px;
  row-gap: 4px;
  font-size: 13px;
  line-height: 1.4;
  text-align: left;
}
.kv-label {
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
}
.kv-value {
  color: #fff;
}
</style>
